// extracted by mini-css-extract-plugin
export default {"item":"passportItem_item__4sKNP"};